import {
  Sun,
  Heart,
  Home,
  AlertCircle,
  Briefcase,
  Calendar,
  CheckCircle,
  Clock,
  XCircle,
} from "lucide-react";

// ===== STATUS COLOR =====
export const getStatusColor = (status, theme, isDarkMode) => {
  switch (status) {
    case "approved":
      return theme.colors.success;
    case "pending":
      return theme.colors.warning;
    case "rejected":
      return theme.colors.danger;
    case "cancelled":
      return isDarkMode
        ? "rgba(255, 255, 255, 0.6)"
        : "rgba(26, 26, 26, 0.6)";
    default:
      return theme.colors.info;
  }
};

// ===== STATUS ICON =====
export const getStatusIcon = (status) => {
  switch (status) {
    case "approved":
      return CheckCircle;
    case "pending":
      return Clock;
    case "rejected":
      return XCircle;
    case "cancelled":
      return AlertCircle;
    default:
      return Clock;
  }
};

// ===== LEAVE TYPE ICON =====
export const getLeaveTypeIcon = (type) => {
  switch (type) {
    case "annual":
      return Sun;
    case "sick":
      return Heart;
    case "maternity":
      return Home;
    case "emergency":
      return AlertCircle;
    case "workFromHome":
      return Briefcase;
    default:
      return Calendar;
  }
};

// ===== LEAVE TYPE COLOR =====
export const getLeaveTypeColor = (type) => {
  switch (type) {
    case "annual":
      return "#f59e0b";
    case "sick":
      return "#ef4444";
    case "maternity":
      return "#10b981";
    case "emergency":
      return "#2e7cba";
    case "workFromHome":
      return "#2e7cba";
    default:
      return "#6b7280";
  }
};

// ===== CALCULATE DURATION =====
export const calculateDuration = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end - start);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
};

// ===== GET TWO INITIALS =====
export const getTwoInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + (parts[1][0] || "")).toUpperCase();
};

// ===== CREATE DEFAULT LEAVE TYPES =====
export const createDefaultLeaveTypes = (theme, t) => {
  const { Sun: SunIcon, Heart: HeartIcon, Home: HomeIcon, AlertCircle: AlertIcon, Briefcase: BriefcaseIcon, Clock: ClockIcon } = {
    Sun, Heart, Home, AlertCircle, Briefcase, Clock,
  };

  return [
    {
      id: "annual",
      name: t.leaveTypes.annual,
      icon: SunIcon,
      color: theme.colors.warning,
      available: 0,
      used: 0,
      description: t.leaveDescriptions.annual,
    },
    {
      id: "sick",
      name: t.leaveTypes.sick,
      icon: HeartIcon,
      color: theme.colors.danger,
      available: 0,
      used: 0,
      description: t.leaveDescriptions.sick,
    },
    {
      id: "maternity",
      name: t.leaveTypes.maternity,
      icon: HomeIcon,
      color: theme.colors.success,
      available: 0,
      used: 0,
      description: t.leaveDescriptions.maternity,
    },
    {
      id: "emergency",
      name: t.leaveTypes.emergency,
      icon: AlertIcon,
      color: theme.colors.info,
      available: 0,
      used: 0,
      description: t.leaveDescriptions.emergency,
    },
    {
      id: "wfh",
      name: t.leaveTypes.workFromHome,
      icon: BriefcaseIcon,
      color: "#2e7cba",
      available: 0,
      used: 0,
      description: t.leaveDescriptions.workFromHome,
    },
    {
      id: "partialDay",
      name: t.leaveTypes.partialDay,
      icon: ClockIcon,
      color: "#0101fa",
      available: 0,
      used: 0,
      description: t.leaveDescriptions.partialDay,
    },
  ];
};